<template >
  <span class="myBtn"
      :style="
      fit !== false ? 'width:100%;' : ''
    "
  >
    <button
        :disabled="disabled"
        :class="workingClass"
        @click="go($event)"
        :style="whatStyle"
    >
      <span
          class="material-icons"
          v-if="material" >{{ material }}</span >
      <slot />
    </button >
    <q-dialog
        v-model="confirmBox"
        persistent >
      <q-card >
        <q-card-section class="row items-center" >
          <q-avatar
              icon="mood_bad"
              color="red"
              text-color="white" />
          <div class="q-ml-sm" >{{ confirm }}</div >
        </q-card-section >

        <q-card-actions align="right" >
          <q-btn
              flat
              label="Cancel"
              color="primary"
              v-close-popup />
          <q-btn
              flat
              label="Yep"
              color="danger"
              v-close-popup
              @click="$emit('click')"
          />
        </q-card-actions >
      </q-card >
    </q-dialog >
  </span >
</template >

<script >
export default {
  name: "sf-button",
  data() {
    return {
      confirmBox: false,
    };
  },
  methods: {
    go(e) {
      if (!this.confirm) {
        this.$emit("click", e);
      } else this.confirmBox = true;
      //     this.$confirm(this.confirm, "Warning", {
      //       confirmButtonText: "OK",
      //       cancelButtonText: "Cancel",
      //       type: "warning"
      //     })
      //       .then(() => {
      //         this.$emit("click", e);
      //       })
      //       .catch(() => {
      //         this.$emit("cancel", e);
      //       });
      // }
    },
  },
  computed: {
    workingClass() {
      let c = "";
      c += this.type ? this.type + " " : "";
      c += this.size ? this.size + " " : "";
      return c;
    },
    whatStyle() {
      let st = (this.right ? "float:right;" : "") + ";overflow:hidden";
      if (this.fit !== false) st += ";width:100%";
      if (this.disabled) st += ';opacity: 60%;'
      return st;
    },
  },
  props: {
    // fullWidth: {
    //   type: Boolean,
    //   default: false,
    // },
    right: {
      type: Boolean,
      default: false,
    },
    material: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      default: "primary",
    },
    confirm: {
      type: String,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    round: {
      type: Boolean,
      default: false,
    },
    circle: {
      type: Boolean,
      default: false,
    },
    fit: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: null,
    },
  },
};
</script >
<style scoped >
.myBtn{
  cursor: pointer;
}
button {
  cursor: pointer;
  padding-top: 3px;
  padding-bottom: 3px;
  padding-left: 6px;
  padding-right: 6px;
  height: 35px;
  border-radius: 4px;
  margin: 3px;
  border: solid 0px #dcdfe6;
}

button.text {

  background: none;
}

button.warning {
  background-color: #e6a23c;
  color: #ffffff;
  box-shadow: 0px 1px 3px #b88437;
}

button.danger {
  background-color: #f56c6c;
  box-shadow: 0px 1px 3px rgb(194, 85, 85);
  color: #ffffff;
}

button.success {
  background-color: #67c23a;
  box-shadow: 0px 1px 3px #559e31;
  color: #ffffff;
}

button.primary {
  background-color: #409eff;
  box-shadow: 0px 1px 3px rgb(55, 140, 226);

  color: #ffffff;
}

button:hover {
  box-shadow: 0px 0px 2px #9093999c;
}

button.small {
  padding-top: 1px;
  padding-bottom: 1px;
  padding-left: 3px;
  padding-right: 3px;
  height: 20px;
  border-radius: 2px;
  margin: 1px;
  border: solid 0px #dcdfe6;
}

/* round{

} */
</style >
